import { EventEmitter } from "events";
import Dispatcher from "../Dispatcher";
import actionTypes from "../actions/ActionTypes";
const CHANGE_EVENT = "aiCaptureChange";
let _fieldRelation = null;
let _allAIOCRGenericFields = [];
let _aiCaptureFields = [];
let _newGenericField = null;
let _currentMonthRequestCount = { monthCount: 0, yearCount: 0, monthlyLimit: 0, yearlyLimit: 0 };
let _lastChange = "";
class AIOCRStore extends EventEmitter {
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  }
  emitChange() {
    this.emit(CHANGE_EVENT);
  }
  getFieldRelation() {
    return _fieldRelation;
  }
  getAICaptureGenericFields() {
    return _allAIOCRGenericFields;
  }
  getAICaptureFields() {
    return _aiCaptureFields;
  }
  getNewGenericField() {
    return _newGenericField;
  }
  getCurrentMonthRequestCount() {
    return _currentMonthRequestCount;
  }
  lastChange() {
    return _lastChange;
  }
}
const store = new AIOCRStore();
Dispatcher.register((action) => {
  _lastChange = action.actionType;
  switch (action.actionType) {
    case actionTypes.GetAICaptureGenericFields:
      _lastChange = actionTypes.GetAICaptureGenericFields;
      _allAIOCRGenericFields = action.Result;
      store.emitChange();
      break;
    case actionTypes.GetAICaptureFields:
      _lastChange = actionTypes.GetAICaptureFields;
      _aiCaptureFields = action.Result;
      store.emitChange();
      break;
    case actionTypes.UpdateAICaptureFields:
      _lastChange = actionTypes.UpdateAICaptureFields;
      store.emitChange();
      break;
    case actionTypes.AddAICaptureGenericField:
      _lastChange = actionTypes.AddAICaptureGenericField;
      _newGenericField = action.Result;
      store.emitChange();
      break;
    case actionTypes.DeleteAICaptureGenericField:
      _lastChange = actionTypes.DeleteAICaptureGenericField;
      store.emitChange();
      break;
    case actionTypes.GetAICaptureCurrentMonthRequestCount:
      _lastChange = actionTypes.GetAICaptureCurrentMonthRequestCount;
      _currentMonthRequestCount = action.Result;
      store.emitChange();
      break;
    default:
  }
});
export default store;
